import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import { useTranslation } from "react-i18next";
import { ActionButton, DefaultButton, IconButton } from '@fluentui/react/lib/Button';
import { Dialog, DialogFooter, DialogType } from '@fluentui/react/lib/Dialog';
import { __onRenderOverflowButton, __onRenderOverflowItem } from '../../../common/CommonFuctions';
import PropTypes from 'prop-types';
import { __ActionStatus, __DocumentTypeKeys, __MessageTypes } from '../../../common/Dictionaries';
import { _checkSecurityUser } from '../../../common/Helpers/HLP_Security';
import { addContractPropValue, deleteContractPropValue, updateContractPropValue } from '../../../services/sBook/contract.service';
import { useDispatch, useSelector } from 'react-redux';
import { action_setContractPropListValues } from '../../../reducers/actions/KPI/actions';
import { getGridLocalization, showMessage } from '../../../common/Helpers';
import JqxGrid, { jqx } from 'jqwidgets-scripts/jqwidgets-react-tsx/jqxgrid';
import CTextBox from '../../../components/Common/CTextBox';
import { Col, Row } from 'react-bootstrap';
import MessageBox from '../../../components/Common/Message/MessageBox';
import 'jqwidgets-scripts/jqwidgets/styles/jqx.light.css';

const DialogPropertyListValues = (props) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { _contractPropListValues: listContractsPropValues } = useSelector((state) => state.maintainerScope);
    
    const { 
        inputParam_EditMode = null,
        inputParam_IsDialogOpen = null,
        inputParam_SetterIsDialogOpen = null,
        inputParam_ContractPropId = null,
    } = props;

    const [objPropValue_Id, setObjPropValue_Id] = useState(0)
    const [objPropValue_Code, setObjPropValue_Code] = useState("");
    const [objPropValue_Name, setObjPropValue_Name] = useState("");
    const [objPropValue_Description, setObjPropValue_Description] = useState("");

    const [messageConfig, setMessageConfig] = useState({
        message : null,
        messageType : "",
        showMessage : false,
    });

    const onAddNewPropertyValue = async () => {
        const item = {
            id: objPropValue_Id,
            cplCode: objPropValue_Code,
            name: objPropValue_Name,
            description: objPropValue_Description,
            contractPropId: inputParam_ContractPropId,
        }
        
        if (objPropValue_Id > 0) {
            await updateContractPropValue(item).then((serviceResponse) => {
                if (serviceResponse.data.succeeded) {
                    const newItems = listContractsPropValues;

                    newItems.forEach(element => {
                        if (element.id === objPropValue_Id) {
                            element.name = item.name;
                            element.description = item.description;
                        }
                    });
    
                    dispatch(action_setContractPropListValues(newItems))
                    showMessage(setMessageConfig, true, __MessageTypes.SUCCESS, t('data-lang-msg-operationperformed'))
                }
                else {
                    showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationpartialerror'))
                }
            }).catch((ex) => {
                showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationpartialerror'))
            });
        }
        else {
            if (!objPropValue_Name || objPropValue_Name.trim() === "") {
                showMessage(setMessageConfig, true, __MessageTypes.WARNING, t('data-lang-msg-requireddatanotset'));
                return;
            }
            await addContractPropValue(item).then((serviceResponse) => {
                if (serviceResponse.data.succeeded) {
                    const itemId = serviceResponse.data.data;
                    item.id = itemId;
                    const newItems = listContractsPropValues.filter(x => x.id !== itemId);
                    newItems.push(item)
                    dispatch(action_setContractPropListValues(newItems))
                    showMessage(setMessageConfig, true, __MessageTypes.SUCCESS, t('data-lang-msg-operationperformed'))
                }
                else {
                    showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationpartialerror'))
                }
            }).catch((ex) => {
                showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationpartialerror'))
            });
        }
    };

    const onDeletePropertyValue = async (itemId) => {
        await deleteContractPropValue(itemId).then((serviceResponse) => {
            if (serviceResponse.data.succeeded) {
                const newItems = listContractsPropValues.filter(x => x.id !== itemId);
                dispatch(action_setContractPropListValues(newItems))
                showMessage(setMessageConfig, true, __MessageTypes.SUCCESS, t('data-lang-msg-operationperformed'))
            }
            else {
                showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationpartialerror'))
            }
        }).catch((ex) => {
            showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationpartialerror'))
        });
    };
    
    const onCloseDialog = () => {
        inputParam_SetterIsDialogOpen()
    };

    const getRowIdFromRowIndex = (rowIndex) => {
        try {
            if (typeof rowIndex === 'object' && rowIndex.boundindex !== undefined) {
                return listContractsPropValues[rowIndex.boundindex].id;
            }
            return listContractsPropValues[rowIndex]?.id;
        } catch (error) {
            
        }
    };

    const actionCellsRenderer = (objSource) => {
        const itemId = getRowIdFromRowIndex(objSource)

        return  <Row>
                    <Col className='mx-auto'>
                        {
                            (itemId === objPropValue_Id) &&
                            <>
                                <IconButton iconProps={{ iconName: 'Edit' }} title="Editar" ariaLabel="Editar" onClick={() => fieldActionHandler(itemId, 'edit')} />
                                <IconButton iconProps={{ iconName: 'Cancel' }} title="Cancelar" ariaLabel="Cancelar" onClick={() => fieldActionHandler(itemId, 'cancel')} />
                                <IconButton iconProps={{ iconName: 'Delete' }} title="Eliminar" ariaLabel="Eliminar" onClick={() => fieldActionHandler(itemId, 'delete')} />
                            </>
                        }
                        {
                            (itemId !== objPropValue_Id) &&
                            <>
                                <IconButton iconProps={{ iconName: 'Edit' }} title="Editar" ariaLabel="Editar" onClick={() => fieldActionHandler(itemId, 'edit')} />
                                <IconButton iconProps={{ iconName: 'Delete' }} title="Eliminar" ariaLabel="Eliminar" onClick={() => fieldActionHandler(itemId, 'delete')} />
                            </>
                        }
                    </Col>
                </Row>
    };

    const onEditPropertyValue = (itemId) => {
        const item = listContractsPropValues.find(x => x.id == itemId);

        setObjPropValue_Id(item.id)
        setObjPropValue_Code(item.cplCode)
        setObjPropValue_Name(item.name)
        setObjPropValue_Description(item.description)
    };

    const onCancelEditPropertyValue = () => {
        setObjPropValue_Id(0);
        setObjPropValue_Code("");
        setObjPropValue_Name("");
        setObjPropValue_Description("");
    };

    const fieldActionHandler = (itemId, actionType) => {
        switch (actionType) {
            case 'edit':
                onEditPropertyValue(itemId)
                break;
            case 'cancel':
                onCancelEditPropertyValue()
                break;
            case 'delete':
                onDeletePropertyValue(itemId)
                break;
        }
    };

    const getColumns = () => {
        const basicColumns = [
            { index: null, text: 'ID',                           dataField: 'id',          uploadMasive: false, exportable: false, width: '0px',   columntype: 'textbox', editable: false, hidden: true },
            { index: null, text: t('data-lang-lbl-actions'),     dataField: 'acciones',    uploadMasive: false, exportable: false, width: '15%', pinned: true,
                createwidget: (row, column, value, htmlElement) => { ReactDOM.render(actionCellsRenderer(row), htmlElement); },
                initwidget: (row, column, value, htmlElement) => { ReactDOM.render(actionCellsRenderer(row), htmlElement); },
            },
            { index: 0,    text: t('data-lang-lbl-name'),        dataField: 'name',        uploadMasive: false, exportable: true,  width: '40%', columntype: 'textbox', editable: false },
            { index: 1,    text: t('data-lang-lbl-description'), dataField: 'description', uploadMasive: false, exportable: true,  width: '45%', columntype: 'textbox', editable: false },
        ]

        return basicColumns;
    };

    return (
        <Dialog
            hidden={!inputParam_IsDialogOpen}
            onDismiss={inputParam_SetterIsDialogOpen}
            minWidth={1000}
            maxWidth={1300}
            dialogContentProps={{
                type: DialogType.normal,
                styles: {header : { borderBottom: "2px solid #e8e8e8" }},
                title: t('data-lang-lbl-propertyvalues'),
            }}
            modalProps={{
                isBlocking: true,
            }}
        >
            {
                listContractsPropValues &&
                <div style={{width: "100%", height: "400px"}} className="access-per-month-form-body overflow-hidden">
                    <div className="align-items-center h-100">
                        <Row className='pb-2'>
                            <Col xl={4}>
                                <CTextBox labelText={t('data-lang-lbl-name')} controlValue={objPropValue_Name} setterControlValue={setObjPropValue_Name} />
                            </Col>
                            <Col xl={6}>
                                <CTextBox labelText={t('data-lang-lbl-description')} controlValue={objPropValue_Description} setterControlValue={setObjPropValue_Description} />
                            </Col>
                            <Col className='col-auto  m-auto'>
                                <ActionButton iconProps={{iconName: "Save"}} text={t('data-lang-btn-save')} onClick={onAddNewPropertyValue} />
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <MessageBox
                                    inputParam_Message={ messageConfig.message }
                                    inputParam_Display={ messageConfig.showMessage }
                                    inputParam_MessageType={ messageConfig.messageType }
                                    inputParam_SetterMessage={ setMessageConfig }
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <JqxGrid
                                    altrows={true}
                                    enabletooltips={true}
                                    width={'100%'}
                                    theme={'light'} 
                                    height={'300px'}
                                    editable={false}
                                    sortable={true}
                                    filterable={true}
                                    showfilterrow={true}
                                    localization={getGridLocalization(t)}
                                    source={ new jqx.dataAdapter({
                                        localData: listContractsPropValues,
                                        dataType: 'array',
                                        dataFields: [
                                            { name: 'id',          type: 'number' },
                                            { name: 'name',        type: 'string' },
                                            { name: 'description', type: 'string' },
                                        ],
                                        id: 'id'
                                    })}
                                    columns={getColumns()}
                                />
                            </Col>
                        </Row>
                        
                    </div>
                </div>
            }
            <DialogFooter>
                <DefaultButton onClick={onCloseDialog} text={t('data-lang-btn-close')} />
            </DialogFooter>
        </Dialog>
    )
};

DialogPropertyListValues.propTypes = {
    inputParam_EditMode: PropTypes.bool.isRequired,
    inputParam_IsDialogOpen: PropTypes.bool.isRequired,
    inputParam_SetterIsDialogOpen: PropTypes.func.isRequired,
    inputParam_DialogEntity: PropTypes.object,
    inputParam_GapAnalyzeId: PropTypes.number,
    inputParam_GapElementId: PropTypes.number,
    inputParam_SetterCauseActionList: PropTypes.func,
    inputParam_SelectedCauses: PropTypes.array,
    inputParam_ContractPropId: PropTypes.number,
};

export default DialogPropertyListValues;